import { render } from "./HomeWhySurveasy.vue?vue&type=template&id=9f12d52c&scoped=true"
import script from "./HomeWhySurveasy.vue?vue&type=script&lang=js"
export * from "./HomeWhySurveasy.vue?vue&type=script&lang=js"

import "./HomeWhySurveasy.vue?vue&type=style&index=0&id=9f12d52c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f12d52c"]])

export default __exports__